import React, { useEffect, useState } from "react";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import {
  DetailFields,
  HaberForm,
  RightDrawerContainer,
} from "../../styledElements";
import { Button, Checkbox, Form, Input, Select } from "antd";
import { Option } from "antd/lib/mentions";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { getAllUsers } from "../../../Services/loginServices";
import {
  addCustomAlert,
  editCustomAlert,
  getAlertsById,
} from "../../../Services/notifications&rolesServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertRed from "../../../Assets/Icons/alertRed.svg";
export default function AddEditAlertDrawer({
  visible,
  setVisible,
  isEdit,
  setEdit,
  selectedRecord,
  setReFetch,
}) {
  const [form] = Form.useForm();
  const [status, setStatus] = useState([]);
  const [recipients, setRecipients] = useState([]);
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const handleClose = () => {
    form.resetFields();
    setVisible(false);
    setEdit(false);
  };
  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };
  const condition = [
    { label: "Greater", value: ">" },
    { label: "Less", value: "<" },
    { label: "Equal", value: "=" },
    { label: "Greater and Equal", value: ">=" },
    { label: "Less and Equal", value: "<=" },
  ];
  const parameter = [
    { label: "Trim Loss", value: "trim_loss" },
    { label: "Fulfillment", value: "fulfillment" },
    { label: "Deckle Utilisation", value: "deckle_utilisation" },
    { label: "Stock %", value: "stock" },
  ];

  const channel = [
    { label: "In App", value: "in_app" },
    { label: "Email", value: "email" },
  ];
  const handleSave = () => {
    form.submit();
  };
  const onFinish = (values) => {
    if (selectedRecipients.length === 0) {
      setActionToaster({
        error: true,
        msg: "Please select recipients",
      });
      showToaster();
      return;
    }
    const body = {
      name: values.name,
      parameter: values.parameter,
      condition: values.condition,
      value: values.value,
      enable_notifications: selectedRecord?.status,
      channel: values?.channel,
      recipients: selectedRecipients,
    };
    (isEdit ? editCustomAlert(selectedRecord.key, body) : addCustomAlert(body))
      .then((res) => {
        // console.log(res);
        setReFetch(true);
        handleClose();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleRecipientsChange = (value) => {
    setSelectedRecipients((prev) => {
      if (!prev.includes(value)) {
        return [...prev, value];
      }
      return prev;
    });
    // remove the selected recipient from available list
    setRecipients((prev) => prev.filter((item) => item !== value));
  };

  const handleRemoveRecipients = (value) => {
    setSelectedRecipients((prev) => prev.filter((item) => item !== value));

    // re-add the recipient to available list if not already present
    setRecipients((prev) => {
      if (!prev.includes(value)) {
        return [...prev, value];
      }
      return prev;
    });
  };

  useEffect(() => {
    getAllUsers()
      .then((res) => {
        // console.log(res);
        let temp = [];
        res.map((item) => {
          temp.push(item.email);
        });
        setRecipients(temp);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  //For Edit custom alert
  useEffect(() => {
    // if (!recipients) return;
    if (isEdit) {
      getAlertsById(selectedRecord.key)
        .then((res) => {
          // console.log(res);
          form.setFieldsValue({
            name: res.name,
            parameter: res.parameter,
            condition: res.condition,
            value: res.value,
            enable_notifications: res.status,
            channel: res.channel,
            recipients: res.recipients[0],
          });
          setSelectedRecipients(res.recipients);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  return (
    <RightDrawerSidebar
      title={isEdit ? `Edit Custom Alert` : `Add Custom Alert`}
      visible={visible}
      onClose={handleClose}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
                form={form}
              >
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Alert name</h5>
                    <p>Enter the name of the Alert to be created</p>
                  </div>
                  <Form.Item
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                    className="selectForm"
                  >
                    <Input placeholder="Alert name" />
                  </Form.Item>
                </div>

                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Parameter</h5>
                    <p>Select the parameter for Alert to be created</p>
                  </div>
                  <Form.Item
                    name="parameter"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                    className="selectForm"
                  >
                    <Select
                      placeholder="Select Ply"
                      // suffixIcon={
                      //   isPlyDropdownOpen ? (
                      //     <DropDownSearchDraw />
                      //   ) : (
                      //     <DownArrowDraw />
                      //   )
                      // }
                      // onBlur={OnPlyToggleSelect}
                      // onFocus={OnPlyToggleSelect}
                      showSearch
                      optionFilterProp="children"
                      // onChange={handlePlyChange}
                    >
                      {parameter.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>

                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Condition</h5>
                    <p>Select the condition you want to apply</p>
                  </div>
                  <Form.Item
                    name="condition"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                    className="selectForm"
                  >
                    <Select
                      placeholder="Select Ply"
                      // suffixIcon={
                      //   isPlyDropdownOpen ? (
                      //     <DropDownSearchDraw />
                      //   ) : (
                      //     <DownArrowDraw />
                      //   )
                      // }
                      // onBlur={OnPlyToggleSelect}
                      // onFocus={OnPlyToggleSelect}
                      showSearch
                      optionFilterProp="children"
                      // onChange={handlePlyChange}
                    >
                      {condition.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>

                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Value</h5>
                    <p>Enter the value for the Alert to be created</p>
                  </div>
                  <Form.Item
                    name="value"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                    className="selectForm"
                  >
                    <Input placeholder="Enter value" />
                  </Form.Item>
                </div>

                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Channel</h5>
                    <p>
                      Select the mode of delivery for the Alert to be created
                    </p>
                  </div>
                  <Form.Item
                    name="channel"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                    className="selectForm boxFormType reverseCheckbox"
                    style={{ paddingBottom: "20px" }}
                  >
                    <Checkbox.Group
                      options={channel}
                      // checked={isChecked}
                      // onChange={onChange}
                      //    onChange={(checkedValues)=>onChange(checkedValues,"global_settings")}
                      //   className="flexRowReverse"
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        marginLeft: "0px",
                        marginRight: "0px",
                        paddingLeft: "0px",
                        paddingRight: "0px",
                      }}
                    />
                  </Form.Item>
                </div>

                <div>
                  <div className="titleWithText">
                    <h5>Recipients</h5>
                    <p>Select the recipients for the Alert to be created</p>
                  </div>
                  <Form.Item
                    name="recipients"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                    className="selectForm"
                  >
                    <Select
                     key={recipients.length}
                      placeholder="Select or type"
                      // suffixIcon={
                      //   isPlyDropdownOpen ? (
                      //     <DropDownSearchDraw />
                      //   ) : (
                      //     <DownArrowDraw />
                      //   )
                      // }
                      // onBlur={OnPlyToggleSelect}
                      // onFocus={OnPlyToggleSelect}
                      showSearch
                      optionFilterProp="children"
                      onChange={handleRecipientsChange}
                    >
                      {recipients?.map((item) => (
                        <Option key={item} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {selectedRecipients.map((item) => (
                    <div
                      key={item}
                      style={{
                        backgroundColor: "#FDF0EF",
                        color: "#EA655B",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        margin: "5px 0px",
                      }}
                    >
                      {item}
                      <Iconmoon
                        icon="cancel"
                        size={16}
                        color="#EA655B"
                        onClick={() => handleRemoveRecipients(item)}
                      />
                    </div>
                  ))}
                </div>
                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      // htmlType="submit"
                      className="themeBtn"
                      onClick={() => handleSave()}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                      {isEdit ? "Save Changes" : "Create"}
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      className="themeBtn noBg"
                      onClick={() => setVisible(false)}
                    >
                      <Iconmoon icon="cancel" size={16} color="#EA655B" />{" "}
                      Cancel
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
          {visibleToaster && actionToaster.error && (
            <AlertContainer
              color="red toaster"
              icon={alertRed}
              msg={actionToaster.msg}
            />
          )}
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
}
